import {useEffect} from "react";
import {useParams, useNavigate, Outlet, useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fetchProjectInfo} from "../../models/ProjectInfo/action";
import {fetchCTranslationKeys} from "../../models/TranslationKeys/action";

export default function LocalizedRoute() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const projectLanguages = useSelector(state => state.projectInfo.items?.languages);
    const {lang} = useParams();

    const setDefaultLanguage = () => {
        const defaultLang = projectLanguages && projectLanguages.length > 0
            ? projectLanguages.find(item => item.isDefault === true)
            : null;

        localStorage.setItem('dataLang', JSON.stringify(defaultLang));
    }

    useEffect(() => {
        dispatch(fetchProjectInfo());
        dispatch(fetchCTranslationKeys());
    }, [dispatch]);

    useEffect(() => { //if
        if (location.pathname === "/") {
            const dataLang = localStorage.getItem("dataLang");
            const search = location.search;

            if (dataLang) {
                const shortName = JSON.parse(dataLang).shortName.toLowerCase();
                navigate(`/${shortName}/home${search}`);
            }
        }
    }, [location.pathname, location.search, navigate]);

    useEffect(() => {
        if (!projectLanguages) return;

        let dataLang = localStorage.getItem('dataLang');

        if (!dataLang) {
            setDefaultLanguage();
            dataLang = localStorage.getItem('dataLang');
        }

        const parsedDataLang = JSON.parse(dataLang);
        const shortName = parsedDataLang.shortName.toLowerCase();
        const search = location.search;

        if (!lang) {
            navigate(`/${shortName}/home${search}`);
        } else {
            const projectLanguage = projectLanguages.find(item => lang === item.shortName.toLowerCase());

            if (projectLanguage) {
                localStorage.setItem('dataLang', JSON.stringify(projectLanguage));

                // redirect to /lang/home if path is exactly /lang or /lang/
                const pathname = location.pathname;
                const langPathRegex = new RegExp(`^/${lang}/?$`);

                if (langPathRegex.test(pathname)) {
                    navigate(`/${lang}/home${search}`, { replace: true });
                }
            } else {
                const updatedPath = `/${shortName}${location.pathname.replace(lang + '/', '')}${search}`;
                navigate(updatedPath);
            }
        }
    }, [projectLanguages, lang, location.pathname, location.search]);


    return <Outlet />;
}
